module.exports = __webpack_public_path__ + "static/media/Saddle.svg";